<template>
  <div class="progress-ring">
    <svg :width="unit" :height="unit" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      <!-- 背景环 -->
      <circle
        cx="100"
        cy="100"
        :r="r"
        :style="ringStyle"
      />
      <!-- 进度环（加 transition 平滑动画） -->
      <circle
        class="progress-circle"
        :class="isCss ? 'is-css' : ''"
        cx="100"
        cy="100"
        :r="r"
        :style="circleStyle"
        transform="rotate(-90 100 100)"
      />
      <!-- 百分比文字 -->
      <text x="100" y="115" :font-size="fontSize + 'rem'" :fill="textColor" text-anchor="middle">
        {{ displayPercent }}%
      </text>
    </svg>
  </div>
</template>

<script>
import { preciseAdd, preciseSubtract, preciseDivide, preciseMultiply } from '@/utils'
export default {
  name: 'ZuCircleProgress',
  props: {
    duration: { type: Number, default: 600 },
    size: { type: [Number, String], default: 70 },
    width: { type: [Number, String], default: 20 },
    radius: { type: [Number, String], default: 80 },
    type: { type: String, default: 'javascript' },
     // butt | round | square  平头 圆角端头
    shape: { type: String, default: 'butt' },
    progress: { type: Number, default: 0 },
    bgColor: { type: String, default: '#e6f0ff' },
    progressColor: { type: String, default: '#4080ff' },
    textColor: { type: String, default: '#bfbfbf' },
    fontSize: { type: [Number, String], default: 24 },
  },
  computed: {
    isCss() {
      return this.type === 'css'
    },
    r() {
      const num = Number(this.radius) || 80
      return num
    },
    unit() {
      const num = Number(this.size) || 60
      return num
    },
    strokeWidth() {
      const num = Number(this.width) || 60
      return num
    },
    totalLength() {
      return this.r * 2 * Math.PI
    },
    offset() {
      if (!this.displayPercent) return this.totalLength
      const num1 = preciseDivide(this.displayPercent, 100)
      const num2 = preciseSubtract(1, num1)
      const num3 = preciseMultiply(num2, this.totalLength)
      return num3
    },
    ringStyle() {
      const obj = {
        fill: 'none',
        stroke: this.bgColor,
        strokeWidth: this.strokeWidth
      }
      return obj
    },
    circleStyle() {
      const obj = {
        fill: 'none',
        stroke: this.progressColor,
        strokeWidth: this.strokeWidth,
        strokeDasharray: this.totalLength,
        strokeDashoffset: this.offset,
        strokeLinecap: this.shape,
      }
      const v = Number(this.duration)
      const d = v ? 0 : v / 1000
      if (d && this.isCss) {
        obj.transition = `width ${d}s ease-in-out`
      }
      return obj
    }
  },
  watch: {
    progress: {
      handler(val) {
        this.change(val)
      },
      immediate: true
    }
  },
  data() {
    return {
      displayPercent: 0,
      timer: 0
    }
  },
  beforeDestroy() {
    this.clear()
  },
  methods: {
    change(val) {
      const num = Number(val) || 0
      setTimeout(() => {
        if (this.isCss) {
          this.displayPercent = num
          return
        }
        this.init(num)
      }, 100)
    },
    init(val) {
      if (!val) return
      const d = Number(this.duration) || 600
      const start = 0
      const end = val
      const stepTime = 16 // 约 60fps
      const totalSteps = preciseDivide(d, stepTime)
      let currentStep = 0

      this.timer = setInterval(() => {
        currentStep++
        const v = Math.min(preciseAdd(start, preciseMultiply(preciseSubtract(end, start), preciseDivide(currentStep, totalSteps))), end)
        if (currentStep >= totalSteps) {
          if (v !== val) v = val
          this.clear()
        }
        this.displayPercent = v
      }, stepTime)
    },
    clear() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = 0
      }
    }
  }
}
</script>

<style>
.progress-ring {
  display: flex;
  align-items: center;
  justify-content: center;
}
.progress-circle.is-css {
  transition: stroke-dashoffset 0.6s ease-in-out;
}
</style>